export default "__VITE_ASSET__npzQyBAg__"